

import React from 'react'
import style from '../../assets/style/findMasjid/masjidList.module.css';
import ReactHtmlParser from 'html-react-parser';

function masjidList({findMasjidData}) {
    const masjids = findMasjidData?.masjid;
  return (
    <div className={style.newsMainDiv}>
    <div className={style.newsTitleDiv}>
      <h3>Masjids List</h3>
    </div>
       {
        masjids?.map((item, index) =>(
        <div className={style.newsMainCards} key={index}>
          <div className={style.newsImage}>
            <img src={item?.image}/>
          </div>
          <div className={style.newsCardsTitle}>
            <p>{item?.name} </p>
            <p className={style.newsCardsDescription}>{ReactHtmlParser(`${item?.web_description}`)}</p>
            {/* <Link to={`/Show-Blog/${newsBlog?.id}`}> */}
           
          </div>
        </div> 
       ))}
 
  </div>
  )
}

export default masjidList

